import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectHomeData, selectWelcomeMessageSave, selectIsEditingWelcomeMessage } from '@/containers/HomePage/HomeSelectors'
import { setIsEditingWelcomeMessage } from '@/containers/HomePage/HomeSlice'
import { homeActions } from '@/containers/HomePage/HomeSagas'

const useWelcomeMessage = () => {
  const dispatch = useDispatch()
  const isEditingWelcomeText = useSelector(selectIsEditingWelcomeMessage)
  const { welcomeMessage, isAdmin } = useSelector(selectHomeData)
  const { tinymceKey } = useSelector(selectAuthData)
  const { isLoading, error, errorMessage } = useSelector(selectWelcomeMessageSave)
  const editorRef = useRef(null)

  const setIsEditingWelcomeText = value => dispatch(setIsEditingWelcomeMessage(value))

  const saveWelcomeMessage = () => {
    if (!editorRef.current) {
      return
    }
    const text = editorRef.current.getContent()
    dispatch({ type: homeActions.SAVE_WELCOME_MESSAGE, text })
  }

  return {
    welcomeMessage,
    isAdmin,
    editorRef,
    isEditingWelcomeText,
    setIsEditingWelcomeText,
    saveWelcomeMessage,
    isLoading,
    errorMessage,
    error,
    tinymceKey,
  }
}

export default useWelcomeMessage
